import { Component, type ErrorInfo, type ReactNode } from "react";

// Without a boundary any render error unmounts the whole app and leaves a blank page.
export class AppErrorBoundary extends Component<{ children: ReactNode }, { failed: boolean }> {
  state = { failed: false };
  static getDerivedStateFromError() { return { failed: true }; }
  componentDidCatch(error: Error, info: ErrorInfo) { console.error("[app] render failed", error, info.componentStack); }
  render() {
    if (!this.state.failed) return this.props.children;
    return <main className="min-h-screen grid place-items-center bg-surface-base p-6"><section role="alert" className="max-w-md space-y-3 rounded border border-border-default bg-canvas p-6 text-sm">
      <h1 className="text-lg font-semibold">画面を表示できませんでした</h1>
      <p className="text-fg-secondary">アプリが更新された可能性があります。再読み込みすると最新の画面で続けられます。</p>
      <div className="flex gap-3"><button type="button" className="rounded bg-brand-700 px-3 py-2 text-white" onClick={() => window.location.reload()}>再読み込み</button><button type="button" className="underline" onClick={() => window.location.assign("/")}>ホームへ戻る</button></div>
    </section></main>;
  }
}
